export default __webpack_public_path__ + "static/media/litho-demo-blog-post-layout-04.eb6ee63b.jpg";